



































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class WareFooter extends Mixins(VueHoduCommon) {

    mounted() : void {

    }

    /**
     * 이용약관으로 이동
     */
    goTermsOfUse() : void {
        this.$router.push('/termsOfUse').catch(e => {});
    }

    /**
     * 개인정보 취급방침으로 이동
     */
    goPrivacyPolicy() : void {
        this.$router.push('/privacyPolicy').catch(e => {});
    }

}

